import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { ErrorProducer, FormComponent } from '../common';

@Directive({ 
    selector: '[errorHighlight]'
})
export class ErrorHighlightDirective implements OnInit, OnDestroy {
    constructor(
        private element: ElementRef, 
        private form: FormComponent
    ) {
    }

    @Input() errorHighlight: string;
    @Input() name: string;
    @Input() producer: ErrorProducer = this.form;

    private _sub;

    get field() {
        return this.errorHighlight || this.name;
    }

    ngOnInit() {
        //if (!this.producer)
        //    throw new Error('You must define [producer] with errorHighlight');
        this._sub = this.producer.errorChanged.subscribe(() => this.update());

        this.element.nativeElement.addEventListener('focus', this._onFocus = () => this.onFocus());
    }

    private _onFocus;

    onFocus() {

        let errorInfo : HTMLElement = <HTMLElement>this.element.nativeElement.previousElementSibling;

        if (errorInfo && !errorInfo.classList.contains('error-info'))
            errorInfo = null;

        if (errorInfo) {
            errorInfo.remove();
        }
    }

    update() {
        let hasError = false;
        let errorMessage = "Invalid value";
        let el : HTMLElement = this.element.nativeElement;
        let errorInfo : HTMLElement = <HTMLElement>el.previousElementSibling;

        if (errorInfo && !errorInfo.classList.contains('error-info'))
            errorInfo = null;

        if (this.field) {
            let fieldError = null;
            if (this.producer.fieldErrors)
                fieldError = this.producer.fieldErrors.find(x => x.field == this.field);
            
            if (fieldError) {
                errorMessage = fieldError.message;
                hasError = true;
            } else {
                hasError = false;
            }
        } else {
            hasError = this.producer.error;
        }

        if (hasError) {
            this.element.nativeElement.classList.add("error");
            if (this.element.nativeElement.scrollIntoView) {
                this.element.nativeElement.scrollIntoView({
                    block: 'center'
                })
            }

            if (errorMessage)
                this.element.nativeElement.title = errorMessage;

            setTimeout(() => {
                if (errorMessage) {
                    if (!errorInfo) {
                        errorInfo = document.createElement('div');
    
                        let thisErrorInfo = errorInfo;
                        errorInfo.addEventListener('click', () => {
                            thisErrorInfo.remove();
                        });
                        errorInfo.classList.add('error-info');
                        el.parentElement.insertBefore(errorInfo, el);
                    }
    
                    errorInfo.innerHTML = `<div>${errorMessage}</div>`;

                    let innerDiv = errorInfo.querySelector('div');
                    innerDiv.style.width = `${el.offsetWidth}px`;
                    let size = Math.max(el.offsetHeight);
                    errorInfo.style.top =  `${size}px`;
                }
            });
        } else {
            this.element.nativeElement.classList.remove("error");
            this.element.nativeElement.title = "";

            if (errorInfo)
                errorInfo.remove();
        }
    }

    ngOnDestroy() {
        if (this._sub)
            this._sub.unsubscribe();
    }
}